import React from "react";
import PropTypes from "prop-types";
import styles from "./AddressList.module.css";
import { AddressItem } from "../AddressItem/AddressItem";

/**
 * Interactive component
 *
 * Shows all saved addresses and adds a border in between each.
 */

export function AddressList({
  addresses,
  onDefault,
  onPrimary,
  onEdit,
  onDelete,
  isTogglerDisabled,
}) {
  return (
    <div className={styles.container}>
      {addresses.map((address, index) => (
        <div key={index} className={styles.addressBubbleContainer}>
          <AddressItem
            addressInfo={address}
            defaultSelected={address.shipping === 1}
            primary={address.primary === 1}
            setDefault={() => onDefault(index)}
            setPrimary={() => onPrimary(index)}
            onEdit={() => onEdit(address.iboAddressId)}
            onDelete={() => onDelete(address)}
            isTogglerDisabled={isTogglerDisabled}
          />
        </div>
      ))}
    </div>
  );
}

AddressList.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object),
};

export default AddressList;
